<template>
  <div class="">
    <!--page header section start-->
    <section class="page-header position-relative overflow-hidden ptb-120 bg-dark" style="background: url('assets/img/page-header-bg.svg')no-repeat bottom left">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 col-md-12">
                    <h1 class="display-5 fw-bold text-white text-start">Plans</h1>
                    <p class="lead text-start">Choose the perfect plan to fit your needs and budget!</p>
                </div>
            </div>
            <div class="bg-circle rounded-circle circle-shape-3 position-absolute bg-dark-light right-5"></div>
        </div>
    </section>
    <!--page header section end-->
    <div class="d-flex justify-content-center align-items-center m-2">
        <div class="pricing-card-plan text-center">
            <h4>Premium</h4>
            <p class="price">£3 <span>/month</span></p>
            <ul class="features text-start">
                <li>Application Selection</li>
                <li>Custom Wallpaper</li>
                <li>Screen Time</li>
                <li>Parent Portal</li>
                <li>Application Blocking</li>
                <li>Website Blocking</li>
                <li>Email Support</li>
                <li>Location Management (Geofencing, Location History, Zone Notification)</li>
                <li>Call and Text History</li>
                <li>Detailed Reports (Apps, Location, Calls, etc)</li>
                <li>Approved Contact List</li>
                <li>Safe Browser</li>
            </ul>
            <button class="btn btn-outline-primary btn-sm mt-2" :style="{ 'background': '#175cff', 'color': 'white' }" type="button" @click="$router.push({ path: '/shop'})">Buy Now</button>
        </div>
    </div>
  </div>
</template>

<script>
import {useToast} from 'vue-toast-notification';
const $toast = useToast();



export default {
  name: 'Prices',
  components: {
    
  },
  props: {
  },
  data() {
    return {
      isDisabled: false,
    };
  },
  methods: {
  },
  beforeMount() {
  },
  created () {
  },
}
</script>
<style scoped>

</style>